import { bool, number, shape, string } from '@thd-nucleus/data-sources';

// Shared by every component that queries `pricing.mapDetail` (WithBundleProducts, BundleSummary,
// BundleProductList, BundleMiniContent) — was byte-identically duplicated in each file.
export const getMapDetailShape = () => shape({
  mapPolicy: string(),
  mapOriginalPriceViolation: bool(),
  mapSpecialPriceViolation: bool(),
  effectiveMap: number({ float: true }),
  dollarOff: number({ float: true }),
  percentageOff: number({ float: true })
});
